import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart as BaseBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

const BarChart = ({ stats, totalCount, bars }) => {
  return (
    <>
      <h2>{totalCount}</h2>
      <BaseBarChart
        width={500}
        height={300}
        data={stats}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        {bars.map(i => (
          <Bar key={i.dataKey} dataKey={i.dataKey} fill={i.color} />
        ))}
      </BaseBarChart>
    </>
  );
};

BarChart.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalCount: PropTypes.string.isRequired,
  bars: PropTypes.arrayOf(
    PropTypes.shape({
      dataKey: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    })
  ).isRequired
};

export default BarChart;
